export const companyAdminLookupEmails = (
  previousEmail?: string | null,
  email?: string | null
): string[] => [
  ...new Set(
    [previousEmail, email]
      .map((value) => value?.trim().toLowerCase())
      .filter((value): value is string => Boolean(value))
  ),
];

export const pickPreferredCompanyAdmin = <
  T extends { email?: string | null },
>(
  users: T[],
  emailsInPriority: string[]
): T | undefined => {
  const byEmail = new Map<string, T>();
  for (const user of users) {
    const email = user.email?.trim().toLowerCase();
    if (email && !byEmail.has(email)) byEmail.set(email, user);
  }
  for (const email of emailsInPriority) {
    const user = byEmail.get(email);
    if (user) return user;
  }
  return undefined;
};

export const shouldBlockCompanyAdminEmailChange = ({
  previousEmail,
  nextEmail,
  currentUserId,
  takenUserId,
}: {
  previousEmail?: string | null;
  nextEmail?: string | null;
  currentUserId?: string | null;
  takenUserId?: string | null;
}): boolean => {
  const previous = previousEmail?.trim().toLowerCase();
  const next = nextEmail?.trim().toLowerCase();
  if (!next || next === previous) return false;
  return Boolean(takenUserId && takenUserId !== currentUserId);
};
